"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _constant = require("../constant");
var getExperienceSubtitle = function getExperienceSubtitle(experience, showLocation) {
  var experienceCountryCity = experience.countryCity ? "".concat(experience.countryCity, " | ") : '';
  var experienceCityName = experience.cityName ? "".concat(experience.cityName, " | ") : '';
  var locationName = experience.international ? experienceCountryCity : experienceCityName;
  var startMonth = _constant.months[Number(experience.startMonth)];
  var endMonth = _constant.months[Number(experience.endMonth)];
  var endYear = experience.endMonth === '13' ? '' : experience.endYear;
  var startDate = "".concat(startMonth, " ").concat(experience.startYear);
  var endDate = endMonth && endYear || experience.endMonth === '13' ? " - ".concat(endMonth, " ").concat(endYear) : '';
  var date = startDate === endDate ? startDate : "".concat(startDate).concat(endDate);
  return showLocation ? "".concat(locationName).concat(date) : "".concat(date);
};
var _default = getExperienceSubtitle;
exports.default = _default;